// extracted by mini-css-extract-plugin
module.exports = {"root":"LanguageTab_root__299Js","button":"LanguageTab_button__1wclN","currentButton":"LanguageTab_currentButton__siUHq"};